<template>
  <div class="container">
    <div class="box">
      <div class="text-404">404</div>
      <div class="text">页面走丢了~~</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "errPage",
  components: {},
}
</script>

<style lang="less" scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
  text-align: center;
  color: #409EFF;

  .box {
    margin-top: -100px;

    .text-404 {
      font-size: 150px;
    }

    .text {
      font-size: 50px;
    }
  }
}


//card
.item {
  display: flex;

  & + & {
    margin-top: 30px;
  }

  .item-index {
    color: #BD3124;
    font-style: italic; // 斜体
    font-weight: bold;
    width: 18px;
    text-align: right;
    margin-right: 8px;
  }

  .one-row {
    width: 200px;
    font-size: 16px;
    overflow: hidden; //溢出隐藏
    white-space: nowrap; //禁止换行
    text-overflow: ellipsis; //...
  }

  .item-desc {
    padding-top: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>